<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="9">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <div class="form-group form-actions float-right pb-2">
          <b-button
            class="mr-2"
            type="submit"
            size="md"
            variant="primary"
            @click="newEntity"
          >
            <i class="fa fa-plus"></i>
            New Boost Email Template
          </b-button>
        </div>
        <div>
          <StyledDialog
            @filterList="filterList"
            :CurrentObject="mySelected"
            EntityType="EmailTemplateBoost"
          >
            <div slot="header">
              <h2>{{ mySelected.TemplateName }}</h2>
            </div>
            <div slot="details">
              <!-- <div>{{ mySelected.Title }}</div>
              <div>{{ mySelected.Email1 }}</div> -->
            </div>
            <span slot="entityType">Email Template</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash-o"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
//import MyBaseTable from "@/components/base/MyBaseTable.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "EmailTemplateLinkList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "TemplateName",
          label: "Template Name",
          sortable: true,
          thStyle: "width: 35%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "TemplateSubject",
          label: "Subject",
          sortable: true,
          thStyle: "width: 35%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "ModifiedDate",
          label: "Modified",
          sortable: true,
          thStyle: "width: 25%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: ""
    };
  },
  props: {},
  components: {
    cTable,
    StyledDialog
    //MyBaseTable
  },
  created() {
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.emailtemplate.boost_links.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["n_user", "emailtemplate", "dealer", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  // computed: mapState({
  //   users: state => state.n_user.n_users,
  //   items: state => state.n_user.n_users,
  //   itemsArray: state => state.n_user.n_users
  // }),
  updated() {
    this.incrementCount;
  },
  methods: {
    async myLoadComponent() {
      //if (!this.$store.state.player.players) {
      //this.$store.dispatch("emailtemplate/fetchLinks");
      await this.$store.dispatch(
        "emailtemplate/fetchBoostLinks",
        this.$store.state.dealer.dealer_edit.dealership_id
      );

      this.filterList();
    },
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')

      this.$store
        .dispatch(
          "emailtemplate/loadBoostLinkEdit",
          record.EmailTemplateBoostID
        )
        .then(() => {
          this.$router.push({ name: "EmailTemplateBoostProfile" });
        });
    },
    newEntity() {
      this.$store
        .dispatch("emailtemplate/newBoostLink", this.createFreshObject())
        .then(() => {
          this.$router.push({ name: "EmailTemplateBoostProfile" });
          //,
          //params: { id: this.event.id }
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.emailtemplate.boost_links;

      this.filteredObjects = this.filteredObjects.filter(
        link =>
          link.TemplateName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          link.TemplateSubject.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    createFreshObject() {
      return {
        EmailTemplateBoostID: -1,
        dealership_id: this.$store.state.dealer.dealer_edit.dealership_id,
        TemplateName: ""
      };
    }
  },
  watch: {
    "$store.state.emailtemplate.boost_links.length": function(
      oldValue,
      newValue
    ) {
      this.filterList();
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>
